import { Code, ConnectError } from "@connectrpc/connect";
import { extractConnectErrorMessage } from "../libs/connect";
import { t } from "../libs/i18n";

export function getRepresentativeCampaignApplyErrorMessage(error: unknown) {
  if (error instanceof ConnectError) {
    if (isAlreadyAppliedError(error)) {
      return t("すでにポイントを受け取り済みです");
    }

    if (isOutOfKyotoCityError(error)) {
      return t("京都市外にお住まいの方はポイントを受け取れません");
    }

    return extractConnectErrorMessage(error);
  }

  if (error instanceof Error) {
    return error.message;
  }

  return t("ポイントの受け取りに失敗しました");
}

function isAlreadyAppliedError(error: ConnectError) {
  if (error.code === Code.AlreadyExists) {
    return true;
  }

  return getNormalizedConnectErrorMessage(error).includes("already exists");
}

function isOutOfKyotoCityError(error: ConnectError) {
  if (error.code === Code.PermissionDenied) {
    return true;
  }

  const message = getNormalizedConnectErrorMessage(error);
  return (
    message.includes("permission_denied") ||
    message.includes("permission denied")
  );
}

function getNormalizedConnectErrorMessage(error: ConnectError) {
  return `${error.rawMessage}\n${error.message}`.toLowerCase();
}
